module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/sightseeing_5-cad5b4ab91482345e98929078455cdc4.jpg";